import { NgModule } from '@angular/core';
import { SupportRoutingModule } from './support-routing.module';
import { SupportConfigModule } from './config/config.module';

@NgModule({
  imports: [
    SupportRoutingModule,
    SupportConfigModule,
  ],
})
export class SupportModule {}
